// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import { miniCartLineStyles } from "@pace/App/Components/MiniCart/MiniCartLineCard";
import color from "@pace/XDL/Utilities/color";
import { mergeWithCss } from "@pace/XDL/Utilities/mergeWithCss";
import { css } from "styled-components";

miniCartLineStyles.specialOrderTooltip = {
    cssOverrides: {
        tooltipClickable: css`
            margin-left: 4px;
            margin-bottom: 5px;
        `,
    },
};

miniCartLineStyles.specialOrderIcon = {
    size: 14,
    color: "common.ui10",
    css: css`
        opacity: 0.5;
    `,
};

miniCartLineStyles.priceContainer = {
    css: css`
        display: flex;
        align-items: flex-end;
    `,
};

miniCartLineStyles.productTooltip = {
    wrapper: {
        css: css`
            margin-bottom: 8px;
            justify-content: flex-start;
        `,
    },
};
miniCartLineStyles.removeCartLineLink = {
    ...mergeWithCss(miniCartLineStyles.removeCartLineLink, {
        css: css`
            ${IconWrapper} {
                &:hover {
                    color: ${color("common.ui8")};
                }
            }
        `,
    }),
};
